module.exports = __webpack_public_path__ + "img/holidays-admin.d6d35410.svg";